/**
 * All GQL queries for post-related queries.
 */

import { gql } from 'react-apollo';

export const SEARCH_POSTS = gql`
    query SearchPosts($tags: [String]!, $page: Int = 0, $limit: Int!, $sfw: Boolean, $blacklist: Blacklist) {
        search(tags: $tags, limit: $limit, page: $page, sfw: $sfw, blacklist: $blacklist) {
            id
            file_url
            file_ext
            rating
            fav_count
            artist
            height
            score
            tags {
                general {
                    name
                }

                artist {
                    name
                }  
                              
                species {
                    name
                }

                copyright {
                    name
                }

                character {
                    name
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/queries/PostQueries.ts